var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArcadeGames(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1256_696479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6523 4.7168H11.5L11.0508 16.9355H21.6523V4.7168Z",
    fill: "#0F0F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.34766 4.7168H11.5V16.9355H1.34766V4.7168Z",
    fill: "#283366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 16.2617H11.5L11.0508 19.6309L11.5 23H23V16.2617Z",
    fill: "#283366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.2617H11.5V23H0V16.2617Z",
    fill: "#404A80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6309 4.7168H11.0508L11.5 14.9141H19.6309V4.7168Z",
    fill: "#2995CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36914 4.7168H11.5V14.9141H3.36914V4.7168Z",
    fill: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2832 4.7168H11.0508L11.5 13.5664H18.2832V4.7168Z",
    fill: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7168 4.7168H11.5V13.5664H4.7168V4.7168Z",
    fill: "#99EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6523 21.6523V17.6094H11.5L11.0508 19.6309L11.5 21.6523H21.6523Z",
    fill: "#0F0F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.34766 17.6094H11.5V21.6523H1.34766V17.6094Z",
    fill: "#283366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45703 14.2402H8.80469V19.6309H7.45703V14.2402Z",
    fill: "#CFCFE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10938 18.957H10.1523V20.3047H6.10938V18.957Z",
    fill: "#A3AACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8477 18.957H14.1953V20.3047H12.8477V18.957Z",
    fill: "#FFDD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.543 18.957H16.8906V20.3047H15.543V18.957Z",
    fill: "#FFDD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2383 18.957H19.5859V20.3047H18.2383V18.957Z",
    fill: "#FFDD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13086 15.5879C9.24729 15.5879 10.1523 14.6828 10.1523 13.5664C10.1523 12.45 9.24729 11.5449 8.13086 11.5449C7.01442 11.5449 6.10938 12.45 6.10938 13.5664C6.10938 14.6828 7.01442 15.5879 8.13086 15.5879Z",
    fill: "#E62E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6113 0L15.7182 2.69531L17.7236 5.39062H22.9991V0H14.6113Z",
    fill: "#283366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0L12.6069 2.69531L14.6123 5.39062H17.7246L14.6123 0H11.5Z",
    fill: "#ECE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.39062H14.6123L11.5 0L11.0508 2.69531L11.5 5.39062Z",
    fill: "#FFBB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38867 0L9.49559 2.69531L11.5009 5.39062V0H8.38867Z",
    fill: "#FFDD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27539 0L6.38231 2.69531L8.38767 5.39062H11.4999L8.38767 0H5.27539Z",
    fill: "#2EE6A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V5.39062H8.38772L5.27544 0H0Z",
    fill: "#404A80"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1256_696479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcadeGames);
export default __webpack_public_path__ + "static/media/ArcadeGames.9139951a791580d563f9d58a46ab5953.svg";
export { ForwardRef as ReactComponent };